import styled from "styled-components"
import { Form } from "@unform/web"

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  height: 100vh;
  width: 100vw;
  overflow: hidden;
`

export const Main = styled.main`
  flex: 1;
  display: grid;
  grid-template-columns: auto 1fr;

  height: 100%;
  min-height: 0;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;
  min-height: 0;

  padding: 15px;
  overflow: hidden;

  h1 {
    margin-bottom: 10px;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 22px;
    }
  }
`

export const GroupBox = styled.div`
  flex: 1;
  min-height: 0;

  display: flex;
  flex-direction: column;

  border-radius: 10px;
  border: 2px solid ${(props) => props.theme.colors.text};
`

export const StyledForm = styled(Form)`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  overflow: hidden;
  margin: 15px;
  gap: 10px;
`

export const FieldsContainer = styled.span`
  display: flex;
  flex-direction: row;

  gap: 5px;

  span {
    display: flex;
    flex-direction: row;

    gap: 5px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const SearchContainer = styled.div`
  flex: 1;
  min-height: 0;
  gap: 5px;

  display: flex;
  flex-direction: column;

  overflow-y: auto;
`

export const SearchCard = styled.div`
  cursor: pointer;

  display: flex;
  flex-direction: column;
  justify-content: center;

  padding: 5px;

  height: 60px;

  color: black;

  border: 2px solid ${(props) => props.theme.colors.primaryBlue};
  border-left: 10px solid ${(props) => props.theme.colors.primaryBlue};

  h3 {
    font-size: 1.1rem;
  }
`

export const ButtonsContainer = styled.span`
  display: flex;
  flex-direction: row;

  gap: 5px;
`

export const SmallButton = styled.button`
  height: 56px;
  width: 56px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  border-radius: 8px;
  background-color: #1fa643;

  &.search {
    background-color: ${(props) => props.theme.colors.primaryBlue};
  }

  svg {
    width: 30px;
    height: 30px;

    stroke-width: 3px;

    color: white;
  }

  @media (max-width: 768px) {
    width: auto;
    height: 28px;

    svg {
      width: 15px;
      height: 15px;
    }
  }
`
